import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=70660227&scoped=true&"
import script from "./StripePayment.vue?vue&type=script&lang=js&"
export * from "./StripePayment.vue?vue&type=script&lang=js&"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=70660227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70660227",
  null
  
)

export default component.exports